import Vue from 'vue';
import { studentStatusColor } from '@/enums/student-status-color';

Vue.filter('studentStatusColor', (statusId) => studentStatusColor[statusId]);
